import { Table } from 'app/shared/models';
import { NameValueString } from '../../../shared/models/name-value';
import { ColumnMap } from './column-map';

export interface ColumnMapperInterface<t> {
  map(data: any): t;
  getSelect?(sourceObject?: object): string;
  setupMap?(table: Table | string): void;
}

export class OdataColumnMapper<t> implements ColumnMapperInterface<t> {
  public static Store: Map<Table, OdataColumnMapper<any>> = new Map();
  public table: Table;
  public tableName: string;

  constructor(public maps: ColumnMap[]) { }

  public setupMap(table: Table | string): void {

    if (typeof table === 'string') {
      this.tableName = table;
    } else {
      this.tableName = Table[table];
      this.table = table as Table;
    }
  }

  public map(data: any): t {
    let result = {};
    this.maps.forEach(m => {
      result[m.name] = data[m.columnname];
    });

    return result as t;
  }

  public getSelect(): string {
    if (!this.maps || !this.maps.length) {
      return '';
    }
    return '&$select=' + this.maps.map(m => m.columnname).join(',');
  }
}

export class CustomColumnMapper<t> implements ColumnMapperInterface<t> {
  constructor(private scope: any, private getQuery: () => string, private mapCb: (data: any) => t) { }

  public getSelect(): string {
    return this.getQuery.call(this.scope);
  }

  public map(data: any): t {
    return this.mapCb.call(this.scope, data);
  }
}

export class ApiColumnMapper<t> implements ColumnMapperInterface<t> {
  public static Store: Map<Table, OdataColumnMapper<any>> = new Map();
  public tableName: string;

  constructor(public maps: ColumnMap[]) { }

  private getSelectFromObject(sourceObject?: object): string {
    if (!sourceObject) {
      return '';
    }
    let mapped: NameValueString[] = [];
    if (!this.maps || !this.maps.length) {
      // use all properties of the sourceObject
      for (let prop in sourceObject) {
        if (sourceObject.hasOwnProperty(prop)) {
          let propValue = sourceObject[prop];
          if (propValue !== null && propValue !== undefined) {
            let one: NameValueString = { name: prop, value: propValue };
            mapped.push(one);
          }
        }
      }
    } else {
      //just get values from sourceObject with properties in this.maps
      let columnNames = this.maps.map(m => m.columnname);
      for (let column of columnNames) {
        if (sourceObject.hasOwnProperty(column)) {
          let propValue = sourceObject[column];
          if (propValue !== null && propValue !== undefined) {
            let one: NameValueString = { name: column, value: propValue };
            mapped.push(one);
          }
        }
      }
    }
    // using mapped construct url
    return mapped.map(m => m.name + '=' + m.value).join('&');
  }

  public map(data: any): t {
    if (this.maps && this.maps.length) {
      let result = {};
      this.maps.forEach(m => {
        result[m.name] = data[m.columnname];
      });
      return result as t;
    } else {
      return data as t;
    }
  }

  public getSelect(sourceObject?: object): string {
    return this.getSelectFromObject(sourceObject);
  }
}